"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var button_next_st_css_1 = require("./button-next.st.css");
var utils_1 = require("../../utils");
var _addAffix = function (Affix, styleClass) {
    return Affix &&
        React.cloneElement(Affix, {
            className: classNames(button_next_st_css_1.classes[styleClass], Affix.props.className),
        });
};
/**
 * ButtonNext
 */
var ButtonNextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonNextComponent, _super);
    function ButtonNextComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonNextComponent.prototype.focus = function () {
        if (this.innerComponentRef && this.innerComponentRef.focus) {
            this.innerComponentRef.focus();
        }
    };
    ButtonNextComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, Component = _a.as, suffixIcon = _a.suffixIcon, prefixIcon = _a.prefixIcon, children = _a.children, disabled = _a.disabled, focusableOnFocus = _a.focusableOnFocus, focusableOnBlur = _a.focusableOnBlur, href = _a.href, contentClassName = _a.contentClassName, contentRef = _a.contentRef, rest = tslib_1.__rest(_a, ["as", "suffixIcon", "prefixIcon", "children", "disabled", "focusableOnFocus", "focusableOnBlur", "href", "contentClassName", "contentRef"]);
        var htmlTabIndex = disabled ? -1 : rest.tabIndex || 0;
        var htmlHref = disabled ? undefined : href;
        var reference = utils_1.isStatelessComponent(Component) && typeof Component !== 'string'
            ? undefined
            : function (ref) { return (_this.innerComponentRef = ref); };
        return (React.createElement(Component, tslib_1.__assign({}, rest, { onFocus: focusableOnFocus, onBlur: focusableOnBlur, disabled: href ? undefined : disabled, href: htmlHref, ref: reference, tabIndex: htmlTabIndex, "aria-disabled": disabled, className: button_next_st_css_1.st(button_next_st_css_1.classes.root, { disabled: disabled }, this.props.className) }),
            _addAffix(prefixIcon, 'prefix'),
            React.createElement("span", { className: button_next_st_css_1.st(button_next_st_css_1.classes.content, contentClassName), ref: contentRef }, children),
            _addAffix(suffixIcon, 'suffix')));
    };
    ButtonNextComponent.defaultProps = { as: 'button', type: 'button' };
    ButtonNextComponent.displayName = 'ButtonNext';
    return ButtonNextComponent;
}(React.Component));
exports.ButtonNext = ButtonNextComponent;
//# sourceMappingURL=button-next.js.map